import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import FormSection from "@my-dld/components/Form/FormSection";
import TextInputField from "@eres/forms-web/TextInputField";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { ErrorContainer } from "@eres/forms";
import PickerInput from "@my-dld/components/Form/PickerInput";
import { BankAccount, PrvSellLookUp, PvtSellLookUp } from "../../../apis/privatesell/enitites";
import { populatePrvtSellLookup } from "../../../apis/privatesell/services";
import { IPrivateSellForm, IPrivateSellFormProps, IPrivateSellFormState } from "./Base";
import { checkNonEmpty } from "@my-dld/components/Form/FormField";
import { validateIBAN } from "@my-dld/utils/IBANUtil";


interface Props extends IPrivateSellFormProps {
	bankDetail?: BankAccount;
}

interface State extends BankAccount, IPrivateSellFormState {
	errorContainer: ErrorContainer;
	Countries: PvtSellLookUp[];
}

export default class BankDetails extends Component<Props, State> implements IPrivateSellForm<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			...props.bankDetail,
			errorContainer: {},
			Countries: [],
			isValid: false,
		};
	}

	isValid = ( _isUserAction?: boolean ) => {
		const state = this.state;
		let isValid = true;
		let errorViews: ErrorContainer = {};
		isValid = checkNonEmpty( state, "accountTitle", errorViews ) && isValid;
		isValid = checkNonEmpty( state, "bankCountry", errorViews ) && isValid;
		isValid = checkNonEmpty( state, "iban", errorViews ) && isValid;
		if ( isValid && state.iban && !validateIBAN( state.iban ) ) {
			isValid = false;
			errorViews.iban = Strings.invalid_iban;
		}
		this.setState( { errorContainer: errorViews } );
		return isValid;
	};

	// componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
	//     const oldData = this.getData(prevState);
	//     const newData = this.getData(this.state);
	//     handleDataUpdate(oldData, newData, prevState, this);
	// }

	getData = ( state: State = this.state ) => {
		return {
			accountTitle: state?.accountTitle,
			bankCountry: state?.bankCountry,
			iban: state?.iban,
		};
	};

	componentDidMount(): void {
		populatePrvtSellLookup( PrvSellLookUp.PRVSell_COUNTRY, this );
	}

	render() {
		const { readonly } = this.props;
		const { errorContainer, Countries } = this.state;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			errorManager: defaultErrorManager,
		};
		const kvProp = { inputClassName: "form-control", holder: this, containerClassName: "col-md-6 form-group" };
		return (
			<div className="tender-registration-form">
				<FormSection title={ Strings.bank_details }>
					<div className={ "row" }>
						<div className={ "col-12" }>
							<div className="alert alert-warning">
								<div className="update-profile-warning-text">{ Strings.amount_transfer_bank_account }</div>
							</div>
						</div>
						<div className={ "col-4" }>
							<TextInputField
								{ ...filedProps }
								id={ "accountTitle" }
								required={ true }
								containerClassName="form-group"
								label={ Strings.account_holder_name }
								error={ errorContainer.accountTitle }
							/>
						</div>
						<div className="col-4">
							<PickerInput
								{ ...kvProp }
								label={ Strings.bank_country }
								id={ "bankCountry" }
								items={ Countries }
								containerClassName="form-group field-style select-control"
								required={ true }
								error={ errorContainer.bankCountry }
								toIdentifier={ ( item: PvtSellLookUp ) => item.identity + "" }
								onValueChange={ ( country?: PvtSellLookUp ) => {
									this.setState( { bankCountry: country } );
								} }
							/>
						</div>
						<div className={ "col-4" }>
							<TextInputField
								{ ...filedProps }
								id={ "iban" }
								required={ true }
								containerClassName="form-group"
								label={ Strings.iban }
								error={ errorContainer.iban }
							/>
						</div>
					</div>
				</FormSection>
			</div>
		);
	}
}
